<template>
    <blockquote
        class="mb-8 p-4 text-[1.5rem] font-bold leading-[1.4] sm:mb-10 sm:py-6 sm:pl-[44px] sm:pr-6 sm:text-[1.75rem] lg:py-8 lg:pl-[60px] lg:pr-10 lg:text-[2rem]"
    >
        <ClientOnly>
            <div class="relative pl-6">
                <span
                    class="absolute left-0 top-0 h-full w-1 rounded-full bg-primary-orange"
                />
                <slot />
            </div>
        </ClientOnly>
    </blockquote>
</template>
